"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[172],{

/***/ 172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ partners_Partners; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(6066);
// EXTERNAL MODULE: ./core/contexts/app/index.tsx + 1 modules
var contexts_app = __webpack_require__(9617);
// EXTERNAL MODULE: ./components/base/gridview/index.tsx + 4 modules
var gridview = __webpack_require__(7923);
// EXTERNAL MODULE: ./components/base/icon/Icon.tsx
var Icon = __webpack_require__(6653);
// EXTERNAL MODULE: ./components/base/image/Image.tsx
var Image = __webpack_require__(4297);
// EXTERNAL MODULE: ./core/hooks/useWidthResize.ts
var useWidthResize = __webpack_require__(4546);
// EXTERNAL MODULE: ./core/hooks/index.ts + 5 modules
var hooks = __webpack_require__(5527);
;// CONCATENATED MODULE: ./components/widgets/partners/Partners.tsx









function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Partners = function(param) {
    var title = param.title, data = param.data;
    var slider = (0,react.useRef)(null);
    var width = (0,useWidthResize/* useWidth */.z)();
    var app = (0,contexts_app/* useApp */.qD)();
    var isMobile = (0,hooks/* useMobile */.XA)(app.headers['user-agent']);
    var renderSlider = function() {
        var settings = {
            dots: false,
            infinite: data && data.length > 6,
            slidesToShow: isMobile ? 2 : 6,
            slidesToScroll: 1,
            autoplay: false,
            speed: 500,
            autoplaySpeed: 4000,
            cssEase: 'linear',
            arrows: false
        };
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "partners-slide",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Container */.W2, {
                size: "medium",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Row */.X2, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(gridview/* Column */.sg, {
                        className: "slidee",
                        xs: {
                            size: 12
                        },
                        children: [
                            data && data.length > 6 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "partners-slide-arrow partners-slide-arrow--prev",
                                onClick: function() {
                                    var ref;
                                    return (ref = slider.current) === null || ref === void 0 ? void 0 : ref.slickPrev();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    name: "arrow-back"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, _objectSpread({}, settings, {
                                ref: slider,
                                children: data === null || data === void 0 ? void 0 : data.map(function(item, index) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                        className: "item",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "item-in",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, _objectSpread({}, item.image, {
                                                    alt: item.title
                                                }))
                                            })
                                        })
                                    }, index);
                                })
                            })),
                            data && data.length > 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "partners-slide-arrow partners-slide-arrow--next",
                                onClick: function() {
                                    var ref;
                                    return (ref = slider.current) === null || ref === void 0 ? void 0 : ref.slickNext();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    name: "arrow-forward"
                                })
                            })
                        ]
                    })
                })
            })
        }));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "partners section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(gridview/* Container */.W2, {
            size: "fluid",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Row */.X2, {
                    xs: {
                        align: 'center'
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                        xs: {
                            size: 12
                        },
                        sm: {
                            size: 12
                        },
                        md: {
                            size: 12
                        },
                        lg: {
                            size: 12
                        },
                        xl: {
                            size: 12
                        },
                        className: "text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "section-title",
                            children: title
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Row */.X2, {
                    children: renderSlider()
                })
            ]
        })
    }));
};
/* harmony default export */ var partners_Partners = (Partners);

;// CONCATENATED MODULE: ./components/widgets/partners/index.ts



/***/ })

}]);